import { __awaiter, __generator } from "tslib";
import { fetchAIHubEnabled } from '@office-start/ai-hub-config-service';
import { getNetworkType } from '@office-start/device-detection-utility';
import { fetchFeatureGates, getFeatureGates, } from '@office-start/feature-gates-service';
import { fetchIdentity } from '@office-start/identity-service';
import { DataSecurityLevel } from '@office-start/instrumentation-types';
import { endSession as otelEndSession, initializeOTel, sendEvent, } from '@office-start/otel-telemetry-service';
import { mark } from '@office-start/performance-service';
import { IDLE_LOW_PRIORITY, IDLE_MEDIUM_PRIORITY, IMMEDIATE_PRIORITY, } from '@office-start/scheduler-service';
import { initializeTelemetryService, logDiagnostic, } from '@office-start/telemetry-service';
import { convertRawPageToPageName } from '@office-start/telemetry-utility';
import { fetchUserEntitlements, getUserEntitlements, } from '@office-start/user-entitlements-service';
import { fullDaysSinceFirstVisit, isFirstUse, } from '@office-start/user-storage-service';
import { getParamFromWindow } from '@office-start/window-utility';
import { getAppWorkloadType } from '../utils';
import { aiHubTelemetryConfig } from './aiHubTelemetryConfig';
import { getAppPlatform, getAppWorkload, getDeviceType, getShellUserContext, } from './instrumentationHelpers';
import { officeTaosHubTelemetryConfig } from './officeTaosHubTelemetryConfig';
export function initializeOfficeInstrumentation(_a, workload, router) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
    var buildDateUtc = _a.buildDateUtc, buildVersion = _a.buildVersion, correlationId = _a.correlationId, deploymentEnvironment = _a.deploymentEnvironment, domainOrigin = _a.domainOrigin, ecsRing = _a.ecsRing, geoName = _a.geoName, requestOrigin = _a.requestOrigin, sessionId = _a.sessionId, preferredCulture = _a.preferredCulture, _8 = _a.flights, flights = _8 === void 0 ? '' : _8, _9 = _a.officeHomeApiRoot, officeHomeApiRoot = _9 === void 0 ? '' : _9, _10 = _a.isCorpNet, isCorpNet = _10 === void 0 ? false : _10, _11 = _a.inMockMode, inMockMode = _11 === void 0 ? false : _11, officeStartManifestVersion = _a.officeStartManifestVersion;
    return __awaiter(this, void 0, void 0, function () {
        var userEntitlementsResult, userEntitlements, _12, _13, isAdmin, isSmb, isIw, isEdu, isEduStudent, isEduFaculty, isDynamics, identity, isFirstVisit, firstVisitAgeInDays, networkType, testTraffic, appPlatform, appWorkload, deviceType, userSegment, featureGatesResult, featureGates, _14, eventCategoryConfig, samplingConfig, isAIHubEnabled, appName, diagnosticTelemetryNamespace, diagnosticOTelAriaTenant, oTelAriaTenant, telemetryNamespace, initialPage, convertedInitialPage, appWorkloadType, appState, otelConfig, error_1;
        return __generator(this, function (_15) {
            switch (_15.label) {
                case 0:
                    _15.trys.push([0, 13, , 14]);
                    userEntitlementsResult = getUserEntitlements();
                    if (!(userEntitlementsResult === null || userEntitlementsResult === void 0 ? void 0 : userEntitlementsResult.result)) return [3 /*break*/, 1];
                    _12 = userEntitlementsResult;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, fetchUserEntitlements()];
                case 2:
                    _12 = _15.sent();
                    _15.label = 3;
                case 3:
                    userEntitlements = (_12).result;
                    if (!userEntitlements) {
                        throw new Error('UserEntitlements not found');
                    }
                    return [4 /*yield*/, getShellUserContext(userEntitlements)];
                case 4:
                    _13 = _15.sent(), isAdmin = _13.isAdmin, isSmb = _13.isSmb, isIw = _13.isIw, isEdu = _13.isEdu, isEduStudent = _13.isEduStudent, isEduFaculty = _13.isEduFaculty, isDynamics = _13.isDynamics;
                    return [4 /*yield*/, fetchIdentity()];
                case 5:
                    identity = _15.sent();
                    return [4 /*yield*/, isFirstUse()];
                case 6:
                    isFirstVisit = _15.sent();
                    return [4 /*yield*/, fullDaysSinceFirstVisit()];
                case 7:
                    firstVisitAgeInDays = _15.sent();
                    networkType = getNetworkType();
                    testTraffic = inMockMode || getParamFromWindow('testtraffic') === '1';
                    appPlatform = getAppPlatform(workload);
                    appWorkload = getAppWorkload(workload);
                    deviceType = getDeviceType();
                    userSegment = {
                        isAdmin: isAdmin,
                        isDynamics: isDynamics,
                        isEdu: isEdu,
                        isEduFaculty: isEduFaculty,
                        isEduStudent: isEduStudent,
                        isFirstVisit: isFirstVisit,
                        isIw: isIw,
                        isSmb: isSmb,
                    };
                    featureGatesResult = getFeatureGates();
                    if (!(featureGatesResult === null || featureGatesResult === void 0 ? void 0 : featureGatesResult.result)) return [3 /*break*/, 8];
                    _14 = featureGatesResult;
                    return [3 /*break*/, 10];
                case 8: return [4 /*yield*/, fetchFeatureGates()];
                case 9:
                    _14 = _15.sent();
                    _15.label = 10;
                case 10:
                    featureGates = _14;
                    eventCategoryConfig = {
                        actionEnabled: ((_c = (_b = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _b === void 0 ? void 0 : _b.clientOTelGates) === null || _c === void 0 ? void 0 : _c.clientOTelClickEnabled) ||
                            true,
                        diagnosticEnabled: (_f = (_e = (_d = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _d === void 0 ? void 0 : _d.clientOTelGates) === null || _e === void 0 ? void 0 : _e.clientOTelDiagnosticEnabled) !== null && _f !== void 0 ? _f : false,
                        errorEnabled: ((_h = (_g = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _g === void 0 ? void 0 : _g.clientOTelGates) === null || _h === void 0 ? void 0 : _h.clientOTelErrorEnabled) ||
                            true,
                        featureEnabled: ((_k = (_j = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _j === void 0 ? void 0 : _j.clientOTelGates) === null || _k === void 0 ? void 0 : _k.clientOTelFeatureEnabled) || true,
                        impressionEnabled: ((_m = (_l = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _l === void 0 ? void 0 : _l.clientOTelGates) === null || _m === void 0 ? void 0 : _m.clientOTelImpressionEnabled) || true,
                        pageViewEnabled: ((_p = (_o = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _o === void 0 ? void 0 : _o.clientOTelGates) === null || _p === void 0 ? void 0 : _p.clientOTelPageViewEnabled) || true,
                        perfEnabled: ((_r = (_q = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _q === void 0 ? void 0 : _q.clientOTelGates) === null || _r === void 0 ? void 0 : _r.clientOTelPerfEnabled) ||
                            true,
                        requestEnabled: ((_t = (_s = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _s === void 0 ? void 0 : _s.clientOTelGates) === null || _t === void 0 ? void 0 : _t.clientOTelRequestEnabled) || true,
                    };
                    samplingConfig = {
                        perfSamplingEnabled: ((_v = (_u = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _u === void 0 ? void 0 : _u.clientOTelGates) === null || _v === void 0 ? void 0 : _v.clientOTelSamplingPerformanceEnabled) || false,
                        requestSamplingEnabled: ((_x = (_w = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _w === void 0 ? void 0 : _w.clientOTelGates) === null || _x === void 0 ? void 0 : _x.clientOTelSamplingRequestEnabled) || false,
                    };
                    if (inMockMode) {
                        initializeTelemetryService([
                            {
                                logEvent: function (_eventName, _properties) {
                                    // Do nothing, do not log or output to console here.
                                },
                                flush: function () {
                                    // Nothing logged...nothing flushed...
                                },
                            },
                        ], function () { return router.getCurrentRoute(); }, eventCategoryConfig, samplingConfig, DataSecurityLevel.Full);
                        // Do not initialize Aria or Otel in mock mode...
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, fetchAIHubEnabled()];
                case 11:
                    isAIHubEnabled = _15.sent();
                    appName = void 0;
                    diagnosticTelemetryNamespace = void 0;
                    diagnosticOTelAriaTenant = void 0;
                    oTelAriaTenant = void 0;
                    telemetryNamespace = void 0;
                    if (isAIHubEnabled) {
                        appName = aiHubTelemetryConfig.appName;
                        diagnosticTelemetryNamespace =
                            aiHubTelemetryConfig.diagnosticTelemetryNamespace;
                        diagnosticOTelAriaTenant =
                            aiHubTelemetryConfig.diagnosticOTelAriaTenant;
                        oTelAriaTenant = aiHubTelemetryConfig.oTelAriaTenant;
                        telemetryNamespace = aiHubTelemetryConfig.telemetryNamespace;
                    }
                    else {
                        appName = officeTaosHubTelemetryConfig.appName;
                        diagnosticTelemetryNamespace =
                            officeTaosHubTelemetryConfig.diagnosticTelemetryNamespace;
                        diagnosticOTelAriaTenant =
                            officeTaosHubTelemetryConfig.diagnosticOTelAriaTenant;
                        oTelAriaTenant = officeTaosHubTelemetryConfig.oTelAriaTenant;
                        telemetryNamespace =
                            officeTaosHubTelemetryConfig.telemetryNamespace;
                    }
                    initialPage = router.getCurrentPageForLogging();
                    convertedInitialPage = convertRawPageToPageName(initialPage);
                    if (convertedInitialPage === 'Unknown') {
                        logDiagnostic({
                            eventName: 'UnknownPageName',
                            params: { InitialPage: initialPage },
                        });
                    }
                    appWorkloadType = getAppWorkloadType(workload);
                    appState = 'Active';
                    try {
                        appState =
                            Windows.UI.WebUI.WebUIApplication.current().getAppState();
                    }
                    catch (_16) {
                        // Ignore if projection is not available.
                    }
                    otelConfig = {
                        appName: appName,
                        appPlatform: appPlatform,
                        appWorkload: appWorkload,
                        appWorkloadType: appWorkloadType,
                        appState: appState,
                        bundleBuildDate: buildDateUtc,
                        bundleBuildId: buildVersion,
                        correlationId: correlationId,
                        dataBoundary: identity === null || identity === void 0 ? void 0 : identity.dataBoundary,
                        deploymentEnvironment: deploymentEnvironment,
                        deviceType: deviceType,
                        domainOrigin: domainOrigin,
                        ecsRing: ecsRing || 'Unknown',
                        firstVisitAgeInDays: firstVisitAgeInDays,
                        flights: flights,
                        identity: identity,
                        IsEudbEndpointEnabled: ((_z = (_y = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _y === void 0 ? void 0 : _y.clientOTelGates) === null || _z === void 0 ? void 0 : _z.clientOTelEudbEndpointEnabled) || false,
                        IsSamplingEnabled: ((_1 = (_0 = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _0 === void 0 ? void 0 : _0.clientOTelGates) === null || _1 === void 0 ? void 0 : _1.clientOTelSamplingEnabled) || false,
                        initialPageName: convertedInitialPage,
                        isCorpNet: isCorpNet,
                        isTestTraffic: testTraffic,
                        networkType: networkType,
                        preferredCulture: preferredCulture,
                        oTelAriaNameSpace: telemetryNamespace,
                        oTelAriaTenant: oTelAriaTenant,
                        oTelEnabled: ((_3 = (_2 = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _2 === void 0 ? void 0 : _2.clientOTelGates) === null || _3 === void 0 ? void 0 : _3.clientOTelEnabled) ||
                            false,
                        requestOrigin: requestOrigin,
                        schedulerPriority: ((_5 = (_4 = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _4 === void 0 ? void 0 : _4.clientOTelGates) === null || _5 === void 0 ? void 0 : _5.clientOTelImmediatePriorityEnabled)
                            ? IMMEDIATE_PRIORITY
                            : ((_7 = (_6 = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _6 === void 0 ? void 0 : _6.clientOTelGates) === null || _7 === void 0 ? void 0 : _7.clientOTelMediumPriorityEnabled)
                                ? IDLE_MEDIUM_PRIORITY
                                : IDLE_LOW_PRIORITY,
                        serverLocation: geoName,
                        sessionId: sessionId,
                        userSegment: userSegment,
                        oTelDiagnosticAriaNameSpace: diagnosticTelemetryNamespace,
                        oTelDiagnosticAriaTenant: diagnosticOTelAriaTenant,
                        officeStartManifestVersion: officeStartManifestVersion,
                        webTechType: 'React',
                    };
                    return [4 /*yield*/, initializeOTel(otelConfig)];
                case 12:
                    _15.sent();
                    initializeTelemetryService([
                        {
                            logEvent: sendEvent,
                            // eslint-disable-next-line @typescript-eslint/no-empty-function
                            flush: function () {
                                otelEndSession(false);
                            },
                        },
                    ], function () { return router.getCurrentRoute(); }, eventCategoryConfig, samplingConfig, DataSecurityLevel.Full, flights);
                    mark("OTEL_Ready" /* KnownPerfInstrumentationEvents.OtelReady */);
                    return [3 /*break*/, 14];
                case 13:
                    error_1 = _15.sent();
                    console.error(error_1);
                    return [3 /*break*/, 14];
                case 14: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=initializeOfficeInstrumentation.js.map